import React from "react"
import { Link } from "gatsby"
import options from "../../../config/options"
import logo from "../../../static/logo/logo.svg"
import iconLine from "../../../static/svg/line-button.svg"
import { Row } from "antd"
import styled from "styled-components"

const HeaderWrapper = styled.header`
  width: 100%;
  padding: 30px 0;
  z-index: 999;
  transition: visibility 0.05s ease-in-out;
  box-shadow: 0px 5px 55px rgba(0, 0, 0, 0.1);
  &.visible {
    visibility: visible;
  }
  &.hidden {
    visibility: hidden;
  }
  .siteLogo {
    max-height: 37px;
    margin-left: 5px;
  }
  .headerRow {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }
  #site__navbar {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0;
    margin-bottom: 0;
    border-bottom: none;
    background: transparent;
  }
  .ctaWrapper {
    display: inline-flex;
    align-items: center;
    padding: 10px 15px;
    margin-left: 15px;
    margin-bottom: 0;
    background-color: #212b3c;
    border-radius: 25.5px;
    line-height: 0;
    a {
      display: inline-flex;
      align-items: center;
      font-family: "Sarabun", sans-serif;
      font-weight: 500;
      font-size: 16px;
      color: #fff;
      padding: 0 10px;
      min-height: auto !important;
      &:hover {
        color: #fff;
      }
      img {
        max-height: 24px;
        margin-right: 5px;
      }
      span {
        margin-bottom: 4px;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .headerRow {
      justify-content: center;
    }
    #site__navbar {
      width: 100%;
      justify-content: center;
      margin-top: 30px;
    }
  }
  @media only screen and (max-width: 375px) {
    .ctaWrapper {
      margin-left: 0;
      margin-top: 30px;
    }
  }
`
const LiWrapper = styled.li`
  display: inline-flex;
  align-items: center;
  border-bottom: none !important;
  max-height: 38px;
  padding: 0 12px;
  white-space: nowrap;
  a {
    font-family: "Sarabun", sans-serif;
    font-weight: 500;
    font-size: 16px !important;
    color: #212b3c !important;
    min-height: auto !important;
  }
  .active {
    &::after {
      content: "";
      display: inline-block;
      margin-top: 2px;
      margin-left: 5px;
      width: 8px;
      height: 8px;
      background-color: #212b3c;
      border-radius: 100%;
    }
  }
  @media only screen and (min-width: 1200px) {
    padding: 0 20px;
  }
`

const HeaderColor = () => {
  let storageUser = null
  const isBrowser = typeof window !== "undefined"
  if (isBrowser) {
    storageUser = JSON.parse(localStorage.getItem("firebaseLMSUser"))
  }

  return (
    <div id="site__header__wrapper">
      <HeaderWrapper id="site__header" className="visible">
        <div className="gb--container">
          <Row className="headerRow">
            <Link to="/" aria-label="Websitecafe Learning">
              <img className="siteLogo" src={logo} alt="Websitecafe Learning" />
            </Link>
            <ul id="site__navbar">
              <LiWrapper key="home">
                <Link activeClassName="active" to="/สอนทำเว็บไซต์-wordpress">
                  คอร์สออนไลน์
                </Link>
              </LiWrapper>
              {storageUser ? (
                <LiWrapper key="dashboard">
                  <Link to="/backend/dashboard">แดชบอร์ด</Link>
                </LiWrapper>
              ) : (
                <LiWrapper key="signin">
                  <Link to="/auth/signin">เข้าสู่ระบบ</Link>
                </LiWrapper>
              )}
              <li key="cta" className="ctaWrapper">
                <a
                  href={options.lineCTA}
                  aria-label="Line"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={iconLine} width="24" height="24" alt="Line" />
                  <span>{options.lineText}</span>
                </a>
              </li>
            </ul>
          </Row>
        </div>
      </HeaderWrapper>
    </div>
  )
}

export default HeaderColor
